export default __webpack_public_path__ + "static/media/info.91cf216a.svg";